import { render, staticRenderFns } from "./FornecedorWFDetalhe.vue?vue&type=template&id=5ec0cac4&"
import script from "./FornecedorWFDetalhe.vue?vue&type=script&lang=js&"
export * from "./FornecedorWFDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./FornecedorWFDetalhe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports